<template>
  <div class="order-list">
    <!-- <h2>订单列表</h2> -->

    <!-- 订单类型标签 -->
    <!-- <div class="order-type-tabs">
      <div class="tab-item active">销售订单</div>
      <div class="tab-item">电商订单</div>
      <div class="tab-item">门店订单</div>
    </div> -->

    <el-tabs
      v-model="queryParams.queryType"
      type="card"
      @tab-click="queryTypeClick"
    >
      <el-tab-pane label="销售订单" name="2" />
      <el-tab-pane label="电商订单" name="1" />
      <el-tab-pane label="门店订单" name="0" />
    </el-tabs>

    <!-- 筛选条件 -->
    <div class="filter-section">
      <div class="date-filters">
        <div
          v-for="item in dateTabs"
          :key="item.value"
          class="date-tab"
          :class="{ active: item.value === queryParams.type }"
          @click="changeDateTab(item.value)"
        >
          {{ item.label }}
        </div>
        <!-- <div class="date-tab">今日</div>
        <div class="date-tab">昨日</div>
        <div class="date-tab">本月</div>
        <div class="date-tab active">上月</div> -->
        <div class="date-range">
          <el-date-picker
            v-model="date"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="dateChange"
          />
        </div>
      </div>

      <!-- <div class="other-filters">
        <el-select
          v-model="shop"
          placeholder="所属店铺"
          size="small"
          class="filter-select"
        >
          <el-option label="所属店铺" value="" />
        </el-select>
        <el-select
          v-model="category"
          placeholder="选择商品分类"
          size="small"
          class="filter-select"
        >
          <el-option label="选择商品分类" value="" />
        </el-select>
        <div class="search-box">
          <el-input
            v-model="searchText"
            placeholder="商品名称/条形码"
            size="small"
            class="search-input"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              size="small"
              class="search-btn"
            />
          </el-input>
        </div>
        <el-button
          type="primary"
          size="small"
          class="excel-btn"
        >生成Excel</el-button>
      </div> -->
    </div>

    <!-- 统计数据卡片 -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="">
          <div class="stat-label">总订单量（含退单）</div>
          <div class="stat-value">{{ summary.orderCount }}</div>
        </div>
        <div class="stat-icon">📊</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">实际销售额(元)</div>
          <div class="stat-value">{{ summary.totalAmount }}</div>
        </div>
        <div class="stat-icon">💰</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">总成本(元)</div>
          <div class="stat-value">{{ summary.totalCost }}</div>
        </div>
        <div class="stat-icon">💸</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">毛利(元)</div>
          <div class="stat-value">{{ summary.profitAmount }}</div>
        </div>
        <div class="stat-icon">📈</div>
      </div>
      <div class="stat-card">
        <div>
          <div class="stat-label">顾客退款(元)</div>
          <div class="stat-value">{{ summary.refundAmount }}</div>
        </div>
        <div class="stat-icon">🔄</div>
      </div>
    </div>

    <!-- 订单表格 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="orderItems"
          stripe
          size="small"
          class="order-table"
        >
          <el-table-column prop="index" label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺" min-width="100" />
          <el-table-column
            prop="productSkuBarCode"
            label="条形码"
            min-width="150"
          />
          <el-table-column prop="cateName" label="商品类别" min-width="120" />
          <el-table-column
            prop="productName"
            label="商品名称"
            min-width="180"
          />
          <el-table-column
            prop="productSkuAttrValue"
            label="规格"
            min-width="80"
          />
          <el-table-column
            prop="skuUnitPoint"
            label="销售单价(元)"
            min-width="100"
            align="right"
          />
          <el-table-column
            prop="costPrice"
            label="成本价"
            min-width="80"
            align="right"
          />
          <el-table-column
            prop="unit"
            label="销售数量"
            min-width="80"
            align="right"
          />
          <el-table-column
            prop="actualAmount"
            label="销售金额"
            min-width="100"
            align="right"
          />
          <el-table-column
            prop="stock"
            label="剩余库存"
            min-width="80"
            align="center"
          />
          <!-- <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="goToDetail(scope.$index)"
              >
                详情
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 移动端表格卡片 -->
      <div v-loading="loading" class="mobile-cards">
        <div
          v-for="(item, index) in orderItems"
          :key="index"
          class="mobile-card"
        >
          <div class="card-header">
            <div class="card-title">商品：{{ item.productName }}</div>
            <div class="card-index">序号：{{ index + 1 }}</div>
          </div>
          <div class="card-content">
            <div class="card-row">
              <span class="label">店铺：</span>
              <span class="value">{{ item.shopName }}</span>
            </div>
            <div class="card-row">
              <span class="label">条形码：</span>
              <span class="value">{{ item.productSkuBarCode }}</span>
            </div>
            <!-- <div class="card-row">
              <span class="label">商品类别：</span>
              <span class="value">{{ item.cateName }}</span>
            </div> -->
            <div class="card-row">
              <span class="label">规格：</span>
              <span class="value">{{ item.productSkuAttrValue }}</span>
            </div>
            <div class="card-row">
              <span class="label">销售单价：</span>
              <span class="value">{{ item.skuUnitPoint }}元</span>
            </div>
            <!-- <div class="card-row">
              <span class="label">成本价：</span>
              <span class="value">{{ item.costPrice }}元</span>
            </div> -->
            <div class="card-row">
              <span class="label">销售数量：</span>
              <span class="value">{{ item.unit }}</span>
            </div>
            <!-- <div class="card-row">
              <span class="label">销售金额：</span>
              <span class="value">{{ item.actualAmount }}元</span>
            </div> -->
            <!-- <div class="card-row">
              <span class="label">剩余库存：</span>
              <span class="value">{{ item.skuTotalUnit }}</span>
            </div> -->
            <!-- <div class="card-row card-action">
              <el-button
                type="primary"
                size="small"
                class="detail-btn"
                @click="goToDetail(index)"
              >
                详情
              </el-button>
            </div> -->
          </div>
        </div>
        <el-empty v-if="orderItems.length === 0" description="暂无销售数据" />
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container pc-pagination">
        <el-pagination
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          background
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="pagination-container mobile-pagination">
        <el-pagination
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          background
          layout="prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  api_summaryCashierOrderBank,
  api_getCashierPageDataBank
} from '@/api/index';
export default {
  name: 'OrderList',
  data() {
    return {
      loading: false,
      date: ['', ''],
      // 订单统计
      summary: {
        totalAmount: 0,
        profitAmount: 0,
        orderCount: 0,
        totalCost: 0,
        refundAmount: 0
      },
      // 筛选条件
      dateTabs: [
        {
          label: '今日',
          value: 1
        },
        {
          label: '昨日',
          value: 2
        },
        {
          label: '本月',
          value: 3
        },
        {
          label: '上月',
          value: 7
        }
      ],
      startDate: '',
      endDate: '',
      shop: '',
      category: '',
      searchText: '',
      queryParams: {
        type: 3,
        productName: '',
        shopId: '',
        beginTime: '',
        endTime: '',
        queryType: '2',
        appId: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 订单数据
      orderItems: []
    };
  },
  computed: {},
  created() {
    console.log('---created---');
    // 初始化总条数
    this.getStatistics();
    this.getOrderList();
    // this.total = this.orderItems.length;
  },
  activated() {
    console.log('---activated---');
    // 组件被激活时调用，这里可以根据需要重新加载数据或执行其他操作
  },
  deactivated() {
    console.log('---deactivated---');
    // 组件被缓存时调用
  },
  methods: {
    goToDetail(index) {
      // 跳转到商品详情页面，传递商品ID
      this.$router.push({
        path: `/product-detail/${index + 1}`
      });
    },
    async getStatistics() {
      try {
        const res = await api_summaryCashierOrderBank(this.queryParams);
        this.summary = res.data || {};
      } catch (error) {
        console.log(error);
      }
    },
    async getOrderList() {
      try {
        this.loading = true;
        const res = await api_getCashierPageDataBank(this.queryParams);
        this.orderItems = res.data.rows || [];
        this.total = res.data.total || 0;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    changeDateTab(e) {
      if (e && Number(e) !== 4) {
        this.date = ['', ''];
        this.queryParams.beginTime = '';
        this.queryParams.endTime = '';
      }
      this.queryParams.type = e;
      this.getStatistics();
      this.reload();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getOrderList();
    },
    queryTypeClick(e) {
      this.queryParams.queryType = e.name;
      this.getStatistics();
      this.reload();
    },
    dateChange(e) {
      if (e) {
        this.queryParams.type = 4;
        this.queryParams.beginTime = e[0];
        this.queryParams.endTime = e[1];
      } else {
        this.queryParams.beginTime = '';
        this.queryParams.endTime = '';
        this.queryParams.type = 3;
      }
      this.getStatistics();
      this.reload();
    },
    reload(refresh = true) {
      if (refresh) {
        this.queryParams.pageNum = 1;
      }
      this.getOrderList();
    }
  }
};
</script>

<style scoped>
.order-list {
  /* padding: 20px; */
}

.order-list h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

/* 订单类型标签 */
.order-type-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-item {
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #666;
}

.tab-item.active {
  background-color: #5470c6;
  color: #fff;
}

/* 筛选条件 */
.filter-section {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-filters {
  display: flex;
  gap: 10px;
  /* margin-bottom: 15px; */
  flex-wrap: wrap;
  align-items: center;
}

.date-tab {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #666;
}

.date-tab.active {
  background-color: #5470c6;
  color: #fff;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
}

.date-input {
  width: 140px;
}

.other-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  min-width: 150px;
}

.search-box {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 200px;
}

.search-input {
  width: 100%;
}

.excel-btn {
  white-space: nowrap;
}

/* 统计数据 */
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 10px;
}

.stat-card {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  /* flex-direction: column;  */
  align-items: center;
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #5470c6;
  margin-bottom: 8px;
}

.stat-icon {
  font-size: 16px;
  color: #999;
}

/* 表格样式 */
.table-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container {
  overflow-x: auto;
}

.order-table {
  width: 100%;
  font-size: 12px;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  font-size: 12px;
}

/* 移动端卡片样式 */
.mobile-cards {
  display: none;
  gap: 15px;
}

.mobile-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  background-color: #f9f9f9;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.card-index {
  font-size: 12px;
  color: #666;
}

.card-content {
  padding: 12px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.card-row:last-child {
  border-bottom: none;
}

.card-row .label {
  font-size: 12px;
  color: #666;
}

.card-row .value {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}
.card-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.mobile-pagination {
  display: none;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .order-list {
    /* padding: 15px; */
  }

  .order-list h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .order-type-tabs {
    flex-wrap: wrap;
    padding: 8px;
  }

  .tab-item {
    padding: 6px 12px;
    font-size: 12px;
  }

  .filter-section {
    padding: 12px;
  }

  .date-filters {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 8px;
  }

  .date-range {
    width: 100%;
    justify-content: space-between;
  }

  .date-input {
    flex: 1;
  }

  .other-filters {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-select,
  .search-box,
  .excel-btn {
    width: 100%;
    min-width: auto;
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-card {
    padding: 12px;
  }

  .stat-value {
    font-size: 18px;
  }

  /* 隐藏表格，显示卡片 */
  .table-container {
    display: none;
  }

  .mobile-cards {
    display: flex;
    flex-direction: column;
  }
  .mobile-pagination {
    display: flex;
  }
  .pc-pagination {
    display: none;
  }
}

@media (max-width: 480px) {
  .order-list {
    /* padding: 10px 0; */
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-card {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: left;
  }

  .stat-label {
    margin-bottom: 0;
  }

  .stat-value {
    margin-bottom: 0;
    margin-right: 10px;
  }
}
</style>
